import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import PerformanceMonitor from './components/PerformanceMonitor/PerformanceMonitor';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import LoadingSpinner from './components/LoadingSpinner/LoadingSpinner';
import './App.css';

// Lazy load components for better performance
const Landing = lazy(() => import('./pages/Landing'));
const Documentation = lazy(() => import('./pages/Documentation'));
const BeginnerGuide = lazy(() => import('./pages/BeginnerGuide'));
const Contact = lazy(() => import('./pages/Contact'));

function App() {
  return (
    <ErrorBoundary>
      <AppProvider>
        <Router>
          <div className="App">
            <PerformanceMonitor />
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/documentation" element={<Documentation />} />
                  <Route path="/beginner-guide" element={<BeginnerGuide />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes>
              </Suspense>
            </ErrorBoundary>
          </div>
        </Router>
      </AppProvider>
    </ErrorBoundary>
  );
}

export default App;